const formatNumber = number => {
  const strNumber = String(number)
  if (strNumber.length === 7) {
    return `${strNumber.charAt(0)}.${strNumber.charAt(1)}M`
  }
  return new Intl.NumberFormat("pt-BR").format(number)
}

export default formatNumber
